import request from '@/utils/request'


//获取订单信息
export const confirmOrder = function (data) {
  console.log('data数据:' + JSON.stringify(data));
  return request.post('/plat-web/woxing/orderConfirmInfo', data, {
    isPlatWeb: true,
  })
}

//去支付
export const toPay = function (data) {
    console.log('data数据:' + JSON.stringify(data));
    return request.post('/plat-web/woxing/toPay', data, {
      isPlatWeb: true,
    })
}
// 获取tips
export function getCustomDetails (data) {
  return request.get('/plat-web/woxing/getCustomDetails', {
    params: data,
    isPlatWeb: true,
  })
}